import { API_BASE } from '../../config/constants';

export async function toBase64(blob: Blob): Promise<string> {
    const buffer = await blob.arrayBuffer();
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const chunkSize = 0x8000;
    for (let i = 0; i < bytes.length; i += chunkSize) {
        binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
    }
    return btoa(binary);
}

export async function downloadBlobFromUrl(url: string): Promise<Blob> {
    const resp = await fetch(url);
    if (!resp.ok) throw new Error('Failed to download file');
    return await resp.blob();
}

export async function createPdfSubmission(apiBase: string, ndaBase64: string, signerName: string, signerEmail: string) {
    const createResponse = await fetch(`${apiBase ?? API_BASE}/api/docuseal/submissions/pdf`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            name: `NDA - ${signerEmail}`,
            send_email: false,
            submitters: [{ name: signerName, email: signerEmail, role: 'Signer' }],
            documents: [
                {
                    name: 'NDA.pdf',
                    file: ndaBase64,
                    fields: [
                        { name: 'Signature', role: 'Signer', type: 'signature', required: true, areas: [{ x: 0.08, y: 0.72, w: 0.38, h: 0.08, page: 2 }] },
                        { name: 'Date', role: 'Signer', type: 'date', required: true, areas: [{ x: 0.55, y: 0.73, w: 0.28, h: 0.06, page: 2 }] },
                    ],
                },
            ],
        }),
    });

    const createPayload = await createResponse.json().catch(() => ({}));
    if (!createResponse.ok || !createPayload?.success || !createPayload?.data?.id) {
        throw new Error(createPayload?.message || 'Unable to create NDA signature request.');
    }

    return createPayload.data;
}

export async function getSubmission(apiBase: string, submissionId: number) {
    const resp = await fetch(`${apiBase ?? API_BASE}/api/docuseal/submissions/${submissionId}`);
    const payload = await resp.json().catch(() => ({}));
    if (!resp.ok || !payload?.success) throw new Error(payload?.message || 'Unable to get submission');
    return payload.data;
}

export async function getSubmissionDocuments(apiBase: string, submissionId: number) {
    const resp = await fetch(`${apiBase ?? API_BASE}/api/docuseal/submissions/${submissionId}/documents`);
    const payload = await resp.json().catch(() => ({}));
    if (!resp.ok || !payload?.success) throw new Error(payload?.message || 'Unable to get submission documents');
    return payload.data;
}

export async function uploadSignedDocument(uploadUserDocumentToAzure: any, signedBlob: Blob, uploadFileName: string, targetUserId: string | number) {
    const signedFile = new File([signedBlob], uploadFileName, { type: 'application/pdf' });
    return await uploadUserDocumentToAzure({ file: signedFile, name: signedFile.name, path: signedFile.name }, targetUserId);
}

const Nda = {
    toBase64,
    downloadBlobFromUrl,
    createPdfSubmission,
    getSubmission,
    getSubmissionDocuments,
    uploadSignedDocument,
};

export default Nda;
